import { faList } from "@fortawesome/pro-regular-svg-icons/faList";
import * as React from "react";
import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconList: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faList} />;
};
